/* screens/settings/NotificationsTab.jsx — настройки рассылки (window.NotificationsTab).
   Таблица-грид Событие / Email / В шапке (фикс №45: на xs/sm — вертикальный стек строк,
   тоглы под названием, не три узкие колонки). Оптимистичное переключение с откатом.
   ХЕНДОФФ → frontend/pages/settings/NotificationsTab.jsx. */

import React from 'react';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { useToast } from '../../app/providers/ToastProvider.jsx';
import { QueryBoundary } from '../../components/patterns/States.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { Switch } from '../../components/ui/Switch.jsx';
import { hooks } from '../../hooks/index.jsx';
import { notificationsReal } from '../../lib/adapters/notifications.js';
import { visiblePreferenceRows } from '../../lib/planSections.js';

  const { useState } = React;
  const { useFakeQuery } = hooks;

  function NotificationsTabInner({ initial }) {
    const toast = useToast();
    const [prefs, setPrefs] = useState(initial);
    // Настройки — на уровне пользователя; строку «аналитика готова» не показываем тому, у
    // кого аналитика заведения закрыта тарифом везде (lib/planSections.js).
    const { workspaces } = useAuth();
    const [savingRow, setSavingRow] = useState(null); // {type, field}

    const toggle = async (type, field) => {
      const idx = prefs.findIndex((p) => p.type === type);
      if (idx < 0) return;
      const prev = prefs[idx][field];
      const next = !prev;
      // оптимистично
      setPrefs((list) => list.map((p) => (p.type === type ? { ...p, [field]: next } : p)));
      setSavingRow({ type, field });
      try {
        // бэк — пакетный PATCH, возвращает полный список; реконсилим из ответа.
        const result = await notificationsReal.updatePreference(type, { [field]: next });
        if (Array.isArray(result) && result.length) setPrefs(result);
      } catch (e) {
        // откат
        setPrefs((list) => list.map((p) => (p.type === type ? { ...p, [field]: prev } : p)));
        toast.show('Не удалось сохранить настройку', 'danger');
      } finally { setSavingRow(null); }
    };

    const isSaving = (type, field) => savingRow && savingRow.type === type;

    return (
      <section className="set-card">
        <div className="set-card__head"><h3 className="t-h4">Уведомления</h3><span className="t-caption text-mute">Куда присылать события</span></div>
        <div className="set-card__body notif-table">
          <div className="notif-row notif-row--head" role="row">
            <span className="t-eyebrow">Событие</span>
            <span className="t-eyebrow notif-col">Email</span>
            <span className="t-eyebrow notif-col">В шапке</span>
          </div>
          {visiblePreferenceRows(prefs, workspaces).map((p) => (
            <div className="notif-row" role="row" key={p.type}>
              <div className="notif-event">
                <div className="t-label">{p.label}</div>
                <div className="t-caption text-dim">{p.description}</div>
              </div>
              <div className="notif-toggle" data-label="Email">
                <Switch checked={p.email_enabled} disabled={isSaving(p.type, 'email_enabled')}
                  ariaLabel={'Email: ' + p.label} onChange={() => toggle(p.type, 'email_enabled')} />
              </div>
              <div className="notif-toggle" data-label="В шапке">
                <Switch checked={p.in_app_enabled} disabled={isSaving(p.type, 'in_app_enabled')}
                  ariaLabel={'В шапке: ' + p.label} onChange={() => toggle(p.type, 'in_app_enabled')} />
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }

  function NotificationsTab() {
    const q = useFakeQuery('notif-prefs', () => notificationsReal.getPreferences(), []);
    return (
      <div className="settings-panel">
        <QueryBoundary loading={q.loading} error={q.error} onRetry={q.reload}
          skeleton={<div className="set-card"><div className="set-card__body"><span className="skeleton" style={{ height: 320, borderRadius: 'var(--radius-md)' }} /></div></div>}>
          {q.data && <NotificationsTabInner initial={q.data} />}
        </QueryBoundary>
      </div>
    );
  }

export { NotificationsTab };
